var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0054 0H26.88V2.87467H22.88V5.74933H26.88V8.624H20.0054V0ZM28.2534 0H35.1307V2.50133H31.1307V3H35.1307V8.74933H28.2534V6.12533H32.2534V5.624H28.2534V0ZM36.5067 0H43.3787V2.50133H39.3787V3H43.3787V8.74933H36.5067V6.12533H40.5067V5.624H36.5067V0Z",
    fill: "#94535C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.976 64L13.4587 58.8587L8 12.5787H56L50.544 58.8533L31.976 64ZM18.792 33.528L19.3013 39.2027H38.9733L38.3147 46.5627L31.984 48.2747H31.9787L25.6587 46.568L25.2533 42.0427H19.5547L20.3493 50.9547L31.976 54.1813L43.6213 50.9547L45.04 35.0507L45.1787 33.528L46.2027 22.0373H17.7707L18.288 27.7147H39.984L39.4667 33.528H18.792Z",
    fill: "#94535C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.ff18905b507bce2182e32e563fa55919.svg";
export { ForwardRef as ReactComponent };